import moment from 'moment'
import { useCallback, useEffect, useState } from 'react'

import { orderByClassesGroupFilterSelection } from 'app/dataProviders/filter-items'
import { subscibeTo } from 'app/common/data-box-store'
import { OrderByClassesDetailsGroup } from 'app/dataTypes/reports/data/common/ordersByClasses'
import { PlainInputDateBox } from 'app/common/ui-next/_filter-compilations/plain-input-date'
import { encashmentsDateFormat } from 'app/dataTypes/reports/data'
import { dateFilter } from 'app/dataProviders/filter-items'


export const dateFormat = 'DD-MM-YYYY'

const getYesterdayDate = () => {
  const yesterday = moment().subtract(1, 'days').format(encashmentsDateFormat)
  return yesterday
}

type Props = {
  id: string
  pending: boolean
}

export const DateFilter = ({ id, pending }: Props) => {
  const [filterVisibility, setFilterVisibility] = useState(true)

  const changePeriodToDefault = useCallback(() => {
    return getYesterdayDate()
  }, [])


  const handleDetailsGroupFilter = useCallback((data: OrderByClassesDetailsGroup) => {
    if (data === OrderByClassesDetailsGroup.ByClasses) {
      setFilterVisibility(true)
      return
    }
    setFilterVisibility(false)
  }, [])

  useEffect(() => {
    const unsubsribeDetailsGroup = subscibeTo<OrderByClassesDetailsGroup>(
      orderByClassesGroupFilterSelection.id,
      handleDetailsGroupFilter,
    )
    return unsubsribeDetailsGroup
  }, [handleDetailsGroupFilter])

  return (
    filterVisibility && <PlainInputDateBox
      id={id}
      loading={pending}
      dateFormat={encashmentsDateFormat}
      dataBoxData={dateFilter}
      getDefaultState={changePeriodToDefault}
    />
  )
}
